type RetryOptions = {
  retries: number; // How many times to retry
  interval: number; // How many ms to wait between retries
};

// eslint-disable-next-line @typescript-eslint/no-shadow
export async function withRetry<F extends () => R, R = F extends () => infer R ? R : never>(
  func: F,
  { retries, interval }: RetryOptions,
): Promise<R> {
  return new Promise((resolve, reject) => {
    const executeWithRetry = (retriesRemaining = retries) => {
      try {
        resolve(func());
      } catch (error: unknown) {
        if (retriesRemaining > 0) {
          setTimeout(() => {
            executeWithRetry(retries - 1);
          }, interval);
        } else {
          reject(error);
        }
      }
    };

    executeWithRetry();
  });
}
